import React, { useEffect, useState } from "react";
import { Calendar, Download, RefreshCw } from "lucide-react";
import { API_BASE_URL } from "src/config/apiBase";
import { decryptToken } from "../utils/getToken";
import { toast } from "react-toastify";

const CrmCalendarActions = ({ leadId, leadName }) => {
  const [loading, setLoading] = useState(false);
  const [gcalConnected, setGcalConnected] = useState(false);
  const url = API_BASE_URL;
  const token = decryptToken("accessToken") || "";

  useEffect(() => {
    fetch(`${url}/leads/google-calendar/status`, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((r) => (r.ok ? r.json() : null))
      .then((res) => setGcalConnected(Boolean(res?.connected)))
      .catch(() => setGcalConnected(false));
  }, [url, token]);

  const fetchLinks = async () => {
    const res = await fetch(`${url}/leads/calendar/${leadId}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    if (!res.ok) throw new Error("Failed");
    return res.json();
  };

  const openGoogle = async () => {
    if (!leadId) return;
    setLoading(true);
    try {
      const data = await fetchLinks();
      window.open(data.googleUrl, "_blank", "noopener,noreferrer");
    } catch {
      toast.error("Could not open Google Calendar");
    } finally {
      setLoading(false);
    }
  };

  const syncToGoogle = async () => {
    if (!leadId) return;
    setLoading(true);
    try {
      const res = await fetch(`${url}/leads/google-calendar/sync/${leadId}`, {
        method: "POST",
        headers: { Authorization: `Bearer ${token}` },
      });
      if (!res.ok) throw new Error("Failed");
      toast.success("Synced to Google Calendar");
    } catch {
      toast.error("Could not sync to Google Calendar");
    } finally {
      setLoading(false);
    }
  };

  const downloadIcs = async () => {
    if (!leadId) return;
    setLoading(true);
    try {
      const res = await fetch(`${url}/leads/calendar/${leadId}?format=ics`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (!res.ok) throw new Error("Failed");
      const blob = await res.blob();
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = `crm-followup-${leadName || leadId}.ics`;
      link.click();
      URL.revokeObjectURL(link.href);
    } catch {
      toast.error("Could not download calendar file");
    } finally {
      setLoading(false);
    }
  };

  if (!leadId) return null;

  return (
    <div className="crm-calendar-actions">
      <span className="crm-calendar-actions__label">Schedule follow-up</span>
      <div className="crm-calendar-actions__btns">
        <button type="button" onClick={openGoogle} disabled={loading}>
          <Calendar size={14} /> Google Calendar
        </button>
        <button type="button" onClick={downloadIcs} disabled={loading}>
          <Download size={14} /> Download .ics
        </button>
        {gcalConnected && (
          <button type="button" onClick={syncToGoogle} disabled={loading} className="crm-calendar-actions__sync">
            <RefreshCw size={14} /> Sync to Google
          </button>
        )}
      </div>
      <p className="crm-insights__muted">
        {gcalConnected
          ? "Google Calendar connected — sync creates/updates an event from the lead reminder."
          : "Uses the lead's reminder date/time, or next hour if unset."}
      </p>
    </div>
  );
};

export default CrmCalendarActions;
